import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import SignUpForm from "../../Forms/SignUp";
import { modalStyles } from "../../../lib/helpers";
import closeIcon from "../../../../../assets/images/icons/icon_close_outline.svg";

/*
 * SignUp component
 * @param {string} action param
 * @param {string} sk - recaptcha site key
 * @param {string} source - source of the form submission
 */
const SignUp = ({ action, sk, source }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleScroll = () => {
      const threshold = 60;
      const signup_banner = document.querySelector(".sign-up-banner");
      if (signup_banner === null) return;

      if (window.scrollY > threshold) {
        signup_banner.classList.add("show-signup-banner");
      } else {
        signup_banner.classList.remove("show-signup-banner");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <p>Get free weekly posts sent to your inbox.</p>
        <a href="#" onClick={toggleModal}>
          Sign Up Now.
        </a>
      </div>
      <Modal
        appElement={document.querySelector("body")}
        className="Modal__Content sm:rounded-3xlh"
        isOpen={modalIsOpen}
        style={modalStyles({
          maxWidth: "620px",
          overflow: "hidden",
          styles: { top: "10%" },
        })}
        overlayClassName="Modal__Overlay"
        onAfterOpen={() => (document.body.style.overflow = "hidden")}
        onAfterClose={() => (document.body.style.overflow = "unset")}
      >
        <div
          className="overflow-hidden align-center content-wrapper sm:rounded-3xl sm:my-0"
          role="dialog"
          aria-modal="true"
          aria-labelledby=""
        >
          <header className="modal-header flex justify-end">
            <button
              onClick={toggleModal}
              className=" close-modal pt-5 pr-5 outline-none bg-transparent border-none"
              data-dismiss="modal"
              type="button"
            >
              <span className="sr-only">Close</span>
              <img alt="close modal" src={closeIcon} />
            </button>
          </header>
          <div className="content-center max-w-lg mx-auto px-4">
            <div className="text-xs font-semibold uppercase">
              Join our mailing list
            </div>
            <h1 className="my-1 text-4xl font-white">Learn with us</h1>
            <h2 className="text-2xl tg-vertical-space font-extralight">
              Get free weekly posts sent to your inbox.
            </h2>
            <SignUpForm
              closeModal={toggleModal}
              formAction={action}
              RECAPTCHA_SITE_KEY={sk}
              source={source}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

SignUp.propTypes = {
  action: PropTypes.string.isRequired,
  sk: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
};

export default SignUp;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Banners/SignUp/index.jsx